import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { isValueNumberType } from '../../../../../utils/common'
import { stopPropagation } from '../../../../../utils/events'
import { ActionSelect } from '../../../../Action'
import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { EntityProfileNavigation } from '../../../../Entity'
import { ProfileActionsWidgetSkeleton } from '../../../../Widget'

import {
  getActionsSkeletonCount,
  getVisibleIconBarActions,
} from './RequestProfileTabEmailsThreadModalActionsHeader.utils'

import * as styles from './RequestProfileTabEmailsThreadModalActionsHeader.module.css'

function RequestProfileTabEmailsThreadModalActionsHeader({
  actionsDisabled,
  currentIndex,
  hasNext,
  hasPrevious,
  iconBarActions,
  isNavigationDisabled,
  isReadyToShowMessage,
  menuActions,
  totalCount,
  onClickAction,
  onNext,
  onPrevious,
}) {
  const { t } = useTranslation()

  const { width } = useScreen()

  function getHandleClickIconAction(action) {
    return event => {
      stopPropagation(event)
      onClickAction({ event, value: action.value })
    }
  }

  const visibleIconBarActions = getVisibleIconBarActions(iconBarActions, width)

  return (
    <div className={styles.RequestProfileTabEmailsThreadModalActionsHeader}>
      <EntityProfileNavigation
        counterText={
          isValueNumberType(currentIndex)
            ? t('RequestProfile.TabEmailsCounterKey', {
                current: currentIndex,
                total: totalCount,
              })
            : null
        }
        disabled={isNavigationDisabled}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        isSkeleton={!isReadyToShowMessage}
        nextTooltip={t('RequestProfile.TabEmailsNavigationNextTooltipKey')}
        previousTooltip={t('RequestProfile.TabEmailsNavigationPrevTooltipKey')}
        onNext={onNext}
        onPrevious={onPrevious}
      />
      <div className={styles.actions}>
        {isReadyToShowMessage ? (
          <>
            {visibleIconBarActions.map(action => (
              <Button.Flat
                isGrey
                beforeIconProps={action.beforeIconProps}
                disabled={actionsDisabled}
                height={BUTTON_HEIGHT_32}
                key={action.value}
                qaName={action.value}
                tooltip={action.tooltip}
                onClick={getHandleClickIconAction(action)}
              />
            ))}
            <ActionSelect
              actions={menuActions}
              disabled={actionsDisabled}
              onClickAction={onClickAction}
            />
          </>
        ) : (
          <ProfileActionsWidgetSkeleton
            actionsCount={getActionsSkeletonCount(width)}
          />
        )}
      </div>
    </div>
  )
}

export default RequestProfileTabEmailsThreadModalActionsHeader
